$(document).ready(function() {

    $(".client_contact_filters #client").change(function(){
        window.location.href = `/clients/${$(this).val()}/contacts`;
    });

    let contactElement = $('#contact');
    let primaryContactElement = $('#primary_contact');
    let clientElement = $('#client');

    initialiseTaggableSelect(contactElement, clientElement);
    initialiseTableElement(contactElement);

    function initialiseTaggableSelect(elem, checkElem) {
        //creates a taggable select 2 and only allows a tag to be created when the checkElem has a value set
        elem.select2({
            tags: true,
            insertTag: function (data, tag) {
                if (checkElem.val() == '') {
                    toastr.error('Client must be populated before creating a contact');
                    return null;
                }

                data.push(tag);
            }
        });
    }

    function initialiseTableElement(elem) {
        //append the item selected to the table within the modal
        elem.on('select2:select', function (e) {
            appendTableElement(contacts[e.params.data.id], e.params.data.text);
        });

        //when an item is unselected remove it from the table
        elem.on('select2:unselect', function (e) {
            $('#contacts-table-body').find(`#contact-${e.params.data.id}`).remove();
        });
    }

    function appendTableElement(item, defaultName) {
        if (!item) {
            item = {
                name: defaultName,
                email: ''
            };
        }

        $('#contacts-table-body').append(`
        <tr id="contact-${item.id}">
            <td>${item.name}</td>
            <td>${item.email}</td>
        </tr>
    `);
    }

    //when the client changes the contact drop downs need to be repopulated
    clientElement.change(function () {
        setSelectOptions(clientElement, contactElement);
        setSelectOptions(clientElement, primaryContactElement);
    });

    function setSelectOptions(clientElem, contactElem) {
        contactElem.empty();

        //if it has a value the contact element should be not be disabled
        if (clientElem.val() != '') {
            contactElem.prop('disabled', '');
        } else {
            contactElem.append('<option value="" selected="selected">Please Select a Contact</option>').trigger('change');
            contactElem.prop('disabled', 'disabled');
        }

        if(!contactElem.prop('multiple')){
            contactElem.append('<option value="" selected="selected">Please Select a Contact</option>')
        }
        $.each(clientElem.find('option:selected').data('contacts'), function (key, value) {
            contactElem.append('<option value=' + value.id + '>' + value.name + '</option>');
        });
    }

    setSelectOptions(clientElement, contactElement);
    setSelectOptions(clientElement, primaryContactElement);

    prepopulateElement(contactElement);
    prepopulateElement(primaryContactElement);

    function prepopulateElement(elem) {
        if (elem.data('prepopulate') != '') {
            if (typeof (elem.data('prepopulate')) == 'object') {
                $.each(elem.data('prepopulate'), function (key, value) {
                    elem.find('option[value="' + value + '"]').prop('selected', 'selected');
                });
            } else {
                elem.find('option[value="' + parseInt(elem.data('prepopulate')) + '"]').prop('selected', 'selected');
            }
        }
    }

    var selectedContacts = $('#contact option:selected');
    selectedContacts.each(function () {
        appendTableElement(contacts[$(this).val()], $(this).val());
    });
});
